import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import TopNavigation from '../../components/TopNavigation';
import HeroSection from './components/HeroSection';
import WhatYouGetSection from './components/WhatYouGetSection';
import IndustriesSection from './components/IndustriesSection';
import HowItWorksSection from './components/HowItWorksSection';
import WhySleeveSection from './components/WhySleeveSection';
import CTASection from './components/CTASection';
import Footer from '../../components/Footer';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Sleeve - Orchestrate Distributed Intelligence Across Cloud and Edge</title>
        <meta
          name="description"
          content="Sleeve coordinates autonomous agents, legacy systems, and human operators across industrial infrastructure — from factory floors to autonomous fleets, tactical networks to maritime operations."
        />
        <meta name="keywords" content="distributed intelligence, agent orchestration, industrial automation, edge computing, autonomous systems" />
        <meta property="og:title" content="Sleeve - Orchestrate Distributed Intelligence" />
        <meta property="og:description" content="Enterprise-grade platform for orchestrating distributed intelligence across cloud, edge, and legacy systems" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <TopNavigation />
        
        <main className="content-area">
          <HeroSection />
          <WhatYouGetSection />
          <IndustriesSection />
          <HowItWorksSection />
          <WhySleeveSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Homepage;